// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-select[data-v-3a9c386c]{min-width:340px}.input-select.is-placeholder[data-v-3a9c386c]{color:#757575}.input-select option[data-v-3a9c386c]{color:#333}.input-select option[disabled][data-v-3a9c386c]{color:#757575}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
